/**
 * LoginForm.js
 * Written by: Alex Kasemir
 */
import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from '@minerva-analytics/pantheon';

import {
  Container,
  Headline,
  EasyFree,
  OptInText,
  TextAndSVG,
  JoinQuizhiveText,
  SVGImage,
  IconTextListWrapper,
} from './LoginForm.styles';
import LoginButtons from '../../components/LoginButtons';
import email from '../../assets/email.svg';
import star from '../../assets/star.svg';
import growthChart from '../../assets/growth-chart.svg';


/**
 * Pops up to ask a user to login
 *
 */
const LoginForm = ({
  hideSubheadline,
  headlineText,
  facebookLogin,
  gmailLogin,
}) => {
  return (
    <Container>
      {
        headlineText
          ? <Headline> { headlineText } </Headline>
          : null
      }
      {
        !hideSubheadline
          ? <EasyFree>{`It's easy and free`}</EasyFree>
          : null
      }
      <LoginButtons facebookLogin={ facebookLogin } gmailLogin={ gmailLogin } />
      <JoinQuizhiveText>Join Quizhive to: </JoinQuizhiveText>
      <IconTextListWrapper>
        <TextAndSVG>
          <SVGImage src={growthChart} alt="growth-img" />
          Track and save your progress
        </TextAndSVG>
        <TextAndSVG>
          <SVGImage src={email} alt="email-img" />
          Get daily trivia emails
        </TextAndSVG>
        <TextAndSVG>
          <SVGImage src={star} alt="star-img" />
          Earn badges
        </TextAndSVG>
      </IconTextListWrapper>
      <OptInText>
        Quizhive will send a Question of the Day to your email daily.
         By signing up, you are agreeing to the
        <NavLink to={ `/privacy` } > privacy policy</NavLink> and
        <NavLink to={ `/terms` } > terms of service</NavLink>.
      </OptInText>
    </Container>
  );
};

LoginForm.propTypes = {
  facebookLogin: PropTypes.func.isRequired,
  gmailLogin: PropTypes.func.isRequired,
  hideSubheadline: PropTypes.bool,
  headlineText: PropTypes.string,
};

export default LoginForm;
